import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
/* empty css                 */
const CardHeading = ({ className, variant = "smallest", children, ...rest }) => /* @__PURE__ */ React.createElement(Heading, { variant, className: classnames("card-heading", className), ...rest }, children);
export {
  CardHeading as default
};
//# sourceMappingURL=CardHeading.js.map
